<template lang="pug">
  span
    v-menu(v-model="showMenu" rounded="lg" allow-overflow attach :close-on-content-click="false" offset-y max-height="360" min-width="320" max-width="320" nudge-bottom="8" z-index="11")
      template(v-slot:activator="{ on, attrs }")
        v-btn.px-2.button-text-normal.button-filter.text-none(v-if="selectedMethods.length > 0" outlined rounded height="28" v-bind="attrs" v-on="on")
          v-icon.mr-1(@click.stop="clear" size=13) $yzi-x-circle
          .text-xs.font-semibold {{ title }}
          .px-1.neutral400--text |
          .text-xs.primary--text.font-medium {{ getSelectedMethods() }}
          v-icon.ml-1(size=16) $yzi-chevron-down
        v-btn.px-2.button-text-normal.border-dashed.button-filter(v-else outlined rounded height="28" v-bind="attrs" v-on="on")
          v-icon.mr-1(size=13) $yzi-plus-circle
          .text-xs.text-none.font-semibold {{ title }}

      .white
        .menu-header.white
          .font-semibold.text-sm.pa-4 {{ $t('filter_by') }} {{ title.toLowerCase() }}
          v-text-field.text-sm.round-xl.mx-4.mb-3(v-model="searchText" @input="queryChanged" outlined :placeholder="$t('search')" dense hide-details clearable)
          v-divider
        div.px-4.pb-4
          v-skeleton-loader.pa-4(v-if="isFetching" type="text@3")
          template(v-else)
            v-radio-group(v-if="panels.length > 0" v-model="methods.panels" hide-details)
              template(v-for="(panel, panelIdx) in panels")
                template(v-if="singleSelection")
                  v-radio(:value="panel")
                    template(v-slot:label)
                      .text-sm.font-normal.primary--text {{ panel.name }}
                  v-divider.basic300.mt-1.mb-2(v-if="panelIdx !== panels.length - 1")
                template(v-else)
                  y-checkbox.mt-1.pt-2(v-model="methods.panels" :value="panel" @change="checkPanel" :key="panel.id")
                    template(#label)
                      .text-sm.neutral700--text {{ panel.name }}
            template(v-else)
              .text-center.py-8.text-xs.neutral500--text No {{ title.toLowerCase() }} found
      .bottom-0.sticky.z-1.white
        .d-flex.align-center.px-4.py-3.border-t
          .text-sm.font-semibold.underline.normal-case.neutral700--text.cursor-pointer(v-if="selectedMethods.length > 0" @click="clear") {{ $t('clear') }}
          v-spacer
          v-btn.button-sm(color="primary" depressed :disabled="disabledButton" @click="apply") {{ $t('apply') }}

</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {debounce} from "@/utils";

export default {
  props: {
    filter: {
      type: Object,
      default: () => ({})
    },
    filterKey: {
      type: String,
      default: 'payment_ref_ids'
    },
    singleSelection: {
      type: Boolean,
    },
    title: {
      type: String,
      default: 'Panel Payment Method'
    }
  },
  data: () => ({
    showMenu: false,
    isFetching: false,
    pmSelfPay: false,
    pmPanel: false,
    panels: [],
    selfpayList: [],
    methods: {
      selfpay: [],
      panels: []
    },
    searchText: '',
  }),
  watch: {
    filter: {
      handler() {
        if (!this.filter.key) {
          this.clearData()
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    disabledButton() {
      return !this.selectedMethods.length > 0
    },
    selectedMethods() {
      return this.methods.selfpay.concat(this.methods.panels)
    }
  },
  mounted() {
    this.fetchPaymentMethods()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchPaymentMethods() {
      this.isFetching = true
      let params = {
        page_size: -1,
        company: this.company.id,
        enabled: true,
        search: this.searchText || '',
      }
      this.$axios.get(`/payment_methods`, {params})
          .then(resp => {
            if (resp.data && resp.data.results) {
              let payment_method = resp.data.results
              this.selfpayList = payment_method.filter(f => f.channel === 'self-pay')
              this.panels = payment_method.filter(f => f.channel === 'panel')
            } else {
              this.selfpayList = []
              this.panels = []
            }
            this.$emit('fetched', resp.data)
          })
          .catch(() => {
          })
          .finally(() => {
            this.isFetching = false
          })
    },
    clear() {
      this.clearData()
      this.$emit('update:filter', {})
    },
    clearData() {
      this.methods = {
        selfpay: [],
        panels: []
      }
      this.pmSelfPay = false
      this.pmPanel = false
      this.checkSelfPay()
      this.checkPanel()
    },
    apply() {
      this.showMenu = false
      const filterKey = this.filterKey ?? 'payment_ref_ids'
      const _selectedMethods = this.selectedMethods.map(method => method.id).join()
      const filter = {key: filterKey, value: _selectedMethods}
      this.$emit('update:filter', filter)
    },
    checkSelfPay() {
      if (this.methods.selfpay.length > 0) {
        this.pmSelfPay = true
      } else {
        this.pmSelfPay = false
      }
    },
    tickSelfPay() {
      if (this.pmSelfPay) {
        this.methods.selfpay = this.selfpayList.map(m => m.id)
      } else {
        this.methods.selfpay = []
      }
    },
    checkPanel() {
      if (this.methods.panels.length > 0) {
        this.pmPanel = true
      } else {
        this.pmPanel = false
      }
    },
    tickPanel() {
      if (this.pmPanel) {
        this.methods.panels = this.panels.map(m => m.id)
      } else {
        this.methods.panels = []
      }
    },
    getSelectedMethods() {
      const count = this.selectedMethods.length

      if (count === 1) return this.selectedMethods[0].name

      return `${count} selected`
    },
    queryChanged: debounce(function () {
      this.fetchPaymentMethods()
    }, 750),
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}
.menu-header {
  top: 0;
  position: sticky;
  z-index: 1;
}
</style>